import { axiosPatientInstance } from "config";
import { useQuery } from "react-query";

function useEncounterMedicationsFile(encounterId: string) {
  return useQuery(
    ["medicationFile", { encounterId }],
    () =>
      axiosPatientInstance.get<Blob>(
        `v1/encounter/${encounterId}/form/files/medications`,
        { responseType: "blob" }
      ),
    { staleTime: 60000 }
  );
}

export { useEncounterMedicationsFile };
